module.exports = __webpack_public_path__ + "img/最佳组织奖.6c8708f4.png";